/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Transforme une date du format dd/mm/yyyy vers yyyy-mm-dd attendu par l'API.
 * Retourne une chaîne vide si la date est incomplète ou invalide.
 */
const stringToAPIDateFormat = (value: string): string => {
  const [day, month, year] = value.split('/');
  const dateFromParam = new Date(+year, +month - 1, +day);
  return Number.isNaN(dateFromParam.getTime())
    ? ''
    : dateFromParam.toLocaleDateString('en-CA');
};

export default stringToAPIDateFormat;
